/*!
 * jQuery Internationalization library
 *
 * Copyright (C) 2012 Santhosh Thottingal
 *
 * jquery.i18n is dual licensed GPLv2 or later and MIT. You don't have to do
 * anything special to choose one license or the other and you don't have to
 * notify anyone which license you are using. You are free to use
 * UniversalLanguageSelector in commercial projects as long as the copyright
 * header is left intact. See files GPL-LICENSE and MIT-LICENSE for details.
 *
 * @licence GNU General Public Licence 2.0 or later
 * @licence MIT License
 */

( function ( $ ) {
    'use strict';

    var nav, I18N,
        slice = Array.prototype.slice;
    /**
     * @constructor
     * @param {Object} options
     */
    I18N = function ( options ) {
        // Load defaults
        this.options = $.extend( {}, I18N.defaults, options );

        this.parser = this.options.parser;
        this.locale = this.options.locale;
        this.messageStore = this.options.messageStore;
        this.languages = {};

        this.init();
    };

    I18N.prototype = {
        /**
         * Initialize by loading locales and setting up
         * String.prototype.toLocaleString and String.locale.
         */
        init: function () {
            var i18n = this;

            // Set locale of String environment
            String.locale = i18n.locale;

            // Override String.localeString method
            String.prototype.toLocaleString = function () {
                var localeParts, localePartIndex, value, locale, fallbackIndex,
                    tryingLocale, message;

                value = this.valueOf();
                locale = i18n.locale;
                fallbackIndex = 0;

                while ( locale ) {
                    // Iterate through locales starting at most-specific until
                    // localization is found. As in fi-Latn-FI, fi-Latn and fi.
                    localeParts = locale.split( '-' );
                    localePartIndex = localeParts.length;

                    do {
                        tryingLocale = localeParts.slice( 0, localePartIndex ).join( '-' );
                        message = i18n.messageStore.get( tryingLocale, value );

                        if ( message ) {
                            return message;
                        }

                        localePartIndex--;
                    } while ( localePartIndex );

                    if ( locale === 'en' ) {
                        break;
                    }

                    locale = ( $.i18n.fallbacks[ i18n.locale ] && $.i18n.fallbacks[ i18n.locale ][ fallbackIndex ] ) ||
                        i18n.options.fallbackLocale;
                    $.i18n.log( 'Trying fallback locale for ' + i18n.locale + ': ' + locale );

                    fallbackIndex++;
                }

                // key not found
                return '';
            };
        },

        /*
         * Destroy the i18n instance.
         */
        destroy: function () {
            $.removeData( document, 'i18n' );
        },

        /**
         * General message loading API This can take a URL string for
         * the json formatted messages. Example:
         * <code>load('path/to/all_localizations.json');</code>
         *
         * To load a localization file for a locale:
         * <code>
         * load('path/to/de-messages.json', 'de' );
         * </code>
         *
         * To load a localization file from a directory:
         * <code>
         * load('path/to/i18n/directory', 'de' );
         * </code>
         * The above method has the advantage of fallback resolution.
         * ie, it will automatically load the fallback locales for de.
         * For most usecases, this is the recommended method.
         * It is optional to have trailing slash at end.
         *
         * A data object containing message key- message translation mappings
         * can also be passed. Example:
         * <code>
         * load( { 'hello' : 'Hello' }, optionalLocale );
         * </code>
         *
         * A source map containing key-value pair of languagename and locations
         * can also be passed. Example:
         * <code>
         * load( {
         * bn: 'i18n/bn.json',
         * he: 'i18n/he.json',
         * en: 'i18n/en.json'
         * } )
         * </code>
         *
         * If the data argument is null/undefined/false,
         * all cached messages for the i18n instance will get reset.
         *
         * @param {string|Object} source
         * @param {string} locale Language tag
         * @return {jQuery.Promise}
         */
        load: function ( source, locale ) {
            var fallbackLocales, locIndex, fallbackLocale, sourceMap = {};

            if (!locale) {
                locale = $.i18n().locale;
            }
            if (!source) {
                source = '/js/i18n/i18n/' + locale + '/'+locale+'.json';
            }

            if ( typeof source === 'string' && source.split( '.' ).pop() !== 'json') {
                // Load specified locale then check for fallbacks when directory is specified in load()
                sourceMap[ locale ] = '/js/i18n/i18n/'+locale + '/' + source + '.json';
                fallbackLocales = ( $.i18n.fallbacks[ locale ] || [] )
                    .concat( this.options.fallbackLocale );
                for ( locIndex in fallbackLocales ) {
                    fallbackLocale = fallbackLocales[ locIndex ];
                    sourceMap[ fallbackLocale ] = '/js/i18n/i18n/' + fallbackLocale + '/' + source + '.json';
                }
                return this.load( sourceMap );
            } else {
                return this.messageStore.load( source );
            }

        },

        /**
         * Does parameter and magic word substitution.
         *
         * @param {string} key Message key
         * @param {Array} parameters Message parameters
         * @return {string}
         */
        parse: function ( key, parameters ) {
            var message = key.toLocaleString();

            // FIXME: This changes the state of the I18N object,
            // should probably not change the 'this.parser' but just
            // pass it to the parser.
            this.parser.language = $.i18n.languages[ $.i18n().locale ] || $.i18n.languages[ 'default' ];
            if ( message === '' ) {
                message = key;
            }
            return this.parser.parse( message, parameters );
        }
    };

    /**
     * Process a message from the $.I18N instance
     * for the current document, stored in jQuery.data(document).
     *
     * @param {string} key Key of the message.
     * @param {string} param1 [param...] Variadic list of parameters for {key}.
     * @return {string|$.I18N} Parsed message, or if no key was given
     * the instance of $.I18N is returned.
     */
    $.i18n = function ( key, param1 ) {
        var parameters,
            i18n = $.data( document, 'i18n' ),
            options = typeof key === 'object' && key;

        // If the locale option for this call is different then the setup so far,
        // update it automatically. This doesn't just change the context for this
        // call but for all future call as well.
        // If there is no i18n setup yet, don't do this. It will be taken care of
        // by the `new I18N` construction below.
        // NOTE: It should only change language for this one call.
        // Then cache instances of I18N somewhere.
        if ( options && options.locale && i18n && i18n.locale !== options.locale ) {
            String.locale = i18n.locale = options.locale;
        }

        if ( !i18n ) {
            i18n = new I18N( options );
            $.data( document, 'i18n', i18n );
        }

        if ( typeof key === 'string' ) {
            if ( param1 !== undefined ) {
                parameters = slice.call( arguments, 1 );
            } else {
                parameters = [];
            }

            return i18n.parse( key, parameters );
        } else {
            // FIXME: remove this feature/bug.
            return i18n;
        }
    };

    $.fn.i18n = function () {
        var i18n = $.data( document, 'i18n' );

        if ( !i18n ) {
            i18n = new I18N();
            $.data( document, 'i18n', i18n );
        }
        String.locale = i18n.locale;
        return this.each( function () {
            var $this = $( this ),
                messageKey = $this.data( 'i18n' ),
                lBracket, rBracket, type, key;

            if ( messageKey ) {
                lBracket = messageKey.indexOf( '[' );
                rBracket = messageKey.indexOf( ']' );
                if ( lBracket !== -1 && rBracket !== -1 && lBracket < rBracket ) {
                    type = messageKey.slice( lBracket + 1, rBracket );
                    key = messageKey.slice( rBracket + 1 );
                    if ( type === 'html' ) {
                        $this.html( i18n.parse( key ) );
                    } else {
                        $this.attr( type, i18n.parse( key ) );
                    }
                } else {
                    $this.text( i18n.parse( messageKey ) );
                }
            } else {
                $this.find( '[data-i18n]' ).i18n();
            }
        } );
    };

    String.locale = String.locale || $( 'html' ).attr( 'lang' );

    if ( !String.locale ) {
        if ( typeof window.navigator !== undefined ) {
            nav = window.navigator;
            String.locale = nav.language || nav.userLanguage || '';
        } else {
            String.locale = '';
        }
    }

    $.i18n.languages = {};
    $.i18n.messageStore = $.i18n.messageStore || {};
    $.i18n.parser = {
        // The default parser only handles variable substitution
        parse: function ( message, parameters ) {
            return message.replace( /\$(\d+)/g, function ( str, match ) {
                var index = parseInt( match, 10 ) - 1;
                return parameters[ index ] !== undefined ? parameters[ index ] : '$' + match;
            } );
        },
        emitter: {}
    };
    $.i18n.fallbacks = {};
    $.i18n.debug = false;
    $.i18n.log = function ( /* arguments */ ) {
        if ( window.console && $.i18n.debug ) {
            var mainArguments = Array.prototype.slice.call(arguments);
            mainArguments.unshift("[i18n]");
            window.console.log.apply( window.console, mainArguments );
        }
    };
    /* Static members */
    I18N.defaults = {
        locale          : String.locale,
        fallbackLocale  : 'en',
        parser          : $.i18n.parser,
        messageStore    : $.i18n.messageStore
    };

    // Expose constructor
    $.i18n.constructor = I18N;

    var MessageStore = function () {
        this.messages = {};
        this.sources = {};
    };

    /**
     * See https://github.com/wikimedia/jquery.i18n/wiki/Specification#wiki-Message_File_Loading
     */
    MessageStore.prototype = {

        /**
         * General message loading API This can take a URL string for
         * the json formatted messages.
         * <code>load('path/to/all_localizations.json');</code>
         *
         * This can also load a localization file for a locale <code>
         * load( 'path/to/de-messages.json', 'de' );
         * </code>
         * A data object containing message key- message translation mappings
         * can also be passed Eg:
         * <code>
         * load( { 'hello' : 'Hello' }, optionalLocale );
         * </code> If the data argument is
         * null/undefined/false,
         * all cached messages for the i18n instance will get reset.
         *
         * @param {string|Object} source
         * @param {string} locale Language tag
         * @return {jQuery.Promise}
         */
        load: function ( source, locale ) {
            var key = null,
                deferred = null,
                deferreds = [],
                messageStore = this;

            if ( typeof source === 'string' ) {
                // This is a URL to the messages file.
                $.i18n.log('Loading messages from: ' + source);

                deferred = jsonMessageLoader( source )
                    .done( function ( localization ) {
                        $.i18n.log('Loaded', source, locale, localization);
                        messageStore.set( locale, localization );
                    } );

                return deferred.promise();
            }

            if ( locale ) {
                // source is an key-value pair of messages for given locale
                messageStore.set( locale, source );

                return $.Deferred().resolve();
            } else {
                // source is a key-value pair of locales and their source
                for ( key in source ) {
                    if ( Object.prototype.hasOwnProperty.call( source, key ) ) {
                        locale = key;
                        // No {locale} given, assume data is a group of languages,
                        // call this function again for each language.
                        deferreds.push( messageStore.load( source[ key ], locale ) );
                    }
                }
                return $.when.apply( $, deferreds );
            }

        },

        /**
         * Set messages to the given locale.
         * If locale exists, add messages to the locale.
         *
         * @param {string} locale
         * @param {Object} messages
         */
        set: function ( locale, messages ) {
            if ( !this.messages[ locale ] ) {
                this.messages[ locale ] = messages;
            } else {
                this.messages[ locale ] = $.extend( this.messages[ locale ], messages );
            }
        },

        /**
         *
         * @param {string} locale
         * @param {string} messageKey
         * @return {boolean}
         */
        get: function ( locale, messageKey ) {
            return this.messages[ locale ] && this.messages[ locale ][ messageKey ];
        }
    };

    function jsonMessageLoader( url ) {
        var deferred = $.Deferred();

        $.getJSON( url )
            .done( deferred.resolve )
            .fail( function ( jqxhr, settings, exception ) {
                $.i18n.log('Error in loading messages from ' + url + ' Exception: ' + exception)
                // Ignore 404 exception, because we are handling fallabacks explicitly
                deferred.resolve();
            } );

        return deferred.promise();
    }

    $.extend( $.i18n.messageStore, new MessageStore() );

    var MessageParser = function ( options ) {
        this.options = $.extend( {}, $.i18n.parser.defaults, options );
        this.language = $.i18n.languages[ String.locale ] || $.i18n.languages[ 'default' ];
        this.emitter = $.i18n.parser.emitter;
    };

    MessageParser.prototype = {

        constructor: MessageParser,

        simpleParse: function ( message, parameters ) {
            return message.replace( /\$(\d+)/g, function ( str, match ) {
                var index = parseInt( match, 10 ) - 1;

                return parameters[ index ] !== undefined ? parameters[ index ] : '$' + match;
            } );
        },

        parse: function ( message, replacements ) {
            if ( message.indexOf( '{{' ) < 0 ) {
                return this.simpleParse( message, replacements );
            }

            this.emitter.language = $.i18n.languages[ $.i18n().locale ] ||
                $.i18n.languages[ 'default' ];

            return this.emitter.emit( this.ast( message ), replacements );
        },

        ast: function ( message ) {
            var pipe, colon, backslash, anyCharacter, dollar, digits, regularLiteral,
                regularLiteralWithoutBar, regularLiteralWithoutSpace, escapedOrLiteralWithoutBar,
                escapedOrRegularLiteral, templateContents, templateName, openTemplate,
                closeTemplate, expression, paramExpression, result,
                pos = 0;

            // Try parsers until one works, if none work return null
            function choice( parserSyntax ) {
                return function () {
                    var i, result;

                    for ( i = 0; i < parserSyntax.length; i++ ) {
                        result = parserSyntax[ i ]();

                        if ( result !== null ) {
                            return result;
                        }
                    }

                    return null;
                };
            }

            // Try several parserSyntax-es in a row.
            // All must succeed; otherwise, return null.
            // This is the only eager one.
            function sequence( parserSyntax ) {
                var i, res,
                    originalPos = pos,
                    result = [];

                for ( i = 0; i < parserSyntax.length; i++ ) {
                    res = parserSyntax[ i ]();

                    if ( res === null ) {
                        pos = originalPos;

                        return null;
                    }

                    result.push( res );
                }

                return result;
            }

            // Run the same parser over and over until it fails.
            // Must succeed a minimum of n times; otherwise, return null.
            function nOrMore( n, p ) {
                return function () {
                    var originalPos = pos,
                        result = [],
                        parsed = p();

                    while ( parsed !== null ) {
                        result.push( parsed );
                        parsed = p();
                    }

                    if ( result.length < n ) {
                        pos = originalPos;

                        return null;
                    }

                    return result;
                };
            }

            // Helpers -- just make parserSyntax out of simpler JS builtin types

            function makeStringParser( s ) {
                var len = s.length;

                return function () {
                    var result = null;

                    if ( message.slice( pos, pos + len ) === s ) {
                        result = s;
                        pos += len;
                    }

                    return result;
                };
            }

            function makeRegexParser( regex ) {
                return function () {
                    var matches = message.slice( pos ).match( regex );

                    if ( matches === null ) {
                        return null;
                    }

                    pos += matches[ 0 ].length;

                    return matches[ 0 ];
                };
            }

            pipe = makeStringParser( '|' );
            colon = makeStringParser( ':' );
            backslash = makeStringParser( '\\' );
            anyCharacter = makeRegexParser( /^./ );
            dollar = makeStringParser( '$' );
            digits = makeRegexParser( /^\d+/ );
            regularLiteral = makeRegexParser( /^[^{}\[\]$\\]/ );
            regularLiteralWithoutBar = makeRegexParser( /^[^{}\[\]$\\|]/ );
            regularLiteralWithoutSpace = makeRegexParser( /^[^{}\[\]$\s]/ );

            // There is a general pattern:
            // parse a thing;
            // if it worked, apply transform,
            // otherwise return null.
            // But using this as a combinator seems to cause problems
            // when combined with nOrMore().
            // May be some scoping issue.
            function transform( p, fn ) {
                return function () {
                    var result = p();

                    return result === null ? null : fn( result );
                };
            }

            // Used to define "literals" within template parameters. The pipe
            // character is the parameter delimeter, so by default
            // it is not a literal in the parameter
            function literalWithoutBar() {
                var result = nOrMore( 1, escapedOrLiteralWithoutBar )();

                return result === null ? null : result.join( '' );
            }

            function literal() {
                var result = nOrMore( 1, escapedOrRegularLiteral )();

                return result === null ? null : result.join( '' );
            }

            function escapedLiteral() {
                var result = sequence( [ backslash, anyCharacter ] );

                return result === null ? null : result[ 1 ];
            }

            choice( [ escapedLiteral, regularLiteralWithoutSpace ] );
            escapedOrLiteralWithoutBar = choice( [ escapedLiteral, regularLiteralWithoutBar ] );
            escapedOrRegularLiteral = choice( [ escapedLiteral, regularLiteral ] );

            function replacement() {
                var result = sequence( [ dollar, digits ] );

                if ( result === null ) {
                    return null;
                }

                return [ 'REPLACE', parseInt( result[ 1 ], 10 ) - 1 ];
            }

            templateName = transform(
                // see $wgLegalTitleChars
                // not allowing : due to the need to catch "PLURAL:$1"
                makeRegexParser( /^[ !"$&'()*,.\/0-9;=?@A-Z\^_`a-z~\x80-\xFF+\-]+/ ),

                function ( result ) {
                    return result.toString();
                }
            );

            function templateParam() {
                var expr,
                    result = sequence( [ pipe, nOrMore( 0, paramExpression ) ] );

                if ( result === null ) {
                    return null;
                }

                expr = result[ 1 ];

                // use a "CONCAT" operator if there are multiple nodes,
                // otherwise return the first node, raw.
                return expr.length > 1 ? [ 'CONCAT' ].concat( expr ) : expr[ 0 ];
            }

            function templateWithReplacement() {
                var result = sequence( [ templateName, colon, replacement ] );

                return result === null ? null : [ result[ 0 ], result[ 2 ] ];
            }

            function templateWithOutReplacement() {
                var result = sequence( [ templateName, colon, paramExpression ] );

                return result === null ? null : [ result[ 0 ], result[ 2 ] ];
            }

            templateContents = choice( [
                function () {
                    var res = sequence( [
                        // templates can have placeholders for dynamic
                        // replacement eg: {{PLURAL:$1|one car|$1 cars}}
                        // or no placeholders eg:
                        // {{GRAMMAR:genitive|{{SITENAME}}}
                        choice( [ templateWithReplacement, templateWithOutReplacement ] ),
                        nOrMore( 0, templateParam )
                    ] );

                    return res === null ? null : res[ 0 ].concat( res[ 1 ] );
                },
                function () {
                    var res = sequence( [ templateName, nOrMore( 0, templateParam ) ] );

                    if ( res === null ) {
                        return null;
                    }

                    return [ res[ 0 ] ].concat( res[ 1 ] );
                }
            ] );

            openTemplate = makeStringParser( '{{' );
            closeTemplate = makeStringParser( '}}' );

            function template() {
                var result = sequence( [ openTemplate, templateContents, closeTemplate ] );

                return result === null ? null : result[ 1 ];
            }

            expression = choice( [ template, replacement, literal ] );
            paramExpression = choice( [ template, replacement, literalWithoutBar ] );

            function start() {
                var result = nOrMore( 0, expression )();

                if ( result === null ) {
                    return null;
                }

                return [ 'CONCAT' ].concat( result );
            }

            result = start();

            /*
             * For success, the pos must have gotten to the end of the input
             * and returned a non-null.
             * n.b. This is part of language infrastructure, so we do not throw an internationalizable message.
             */
            if ( result === null || pos !== message.length ) {
                throw new Error( 'Parse error at position ' + pos.toString() + ' in input: ' + message );
            }

            return result;
        }

    };

    $.extend( $.i18n.parser, new MessageParser() );
}( jQuery, window ) );